// google-translate-cleaner.js — también al inicio
(function() {
    const cleanGoogleTranslate = () => {
      // remover clases traducidas
      document.querySelectorAll('.translated-ltr, .translated-rtl').forEach((el) => {
        el.classList.remove('translated-ltr', 'translated-rtl');
      });
  
      // desplegar etiquetas <font> (mueve hijos y elimina <font>)
      document.querySelectorAll('font').forEach((el) => {
        const parent = el.parentNode;
        if (!parent) return;
        while (el.firstChild) parent.insertBefore(el.firstChild, el);
        try { parent.removeChild(el); } catch (e) { /* ignore */ }
      });
  
      // opcional: quitar atributos translate que puedan crear problemas
      document.querySelectorAll('[translate]').forEach((el) => {
        try { el.removeAttribute('translate'); } catch (e) {}
      });
    };
  
    // ejecutarlo ya (por si ya tradujeron antes de cargar)
    try { cleanGoogleTranslate(); } catch(e) {}
  
    // observer para cambios futuros
    const observer = new MutationObserver((mutations) => {
      // solo llamar limpieza cuando se añadan nodos o atributos (para perf)
      for (const m of mutations) {
        if (m.addedNodes?.length || m.type === 'attributes') {
          cleanGoogleTranslate();
          break;
        }
      }
    });
  
    try {
      observer.observe(document.documentElement || document.body, {
        attributes: true,
        childList: true,
        subtree: true,
      });
    } catch(e) {
      // fallback: periodic cleanup si observe falla
      setInterval(cleanGoogleTranslate, 1000);
    }
  })();
  